import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import _ from 'lodash'
import { CAMPAIGN_STATUS_ENUM, CampaignState } from 'state/campaigns'
import { SaveContainer, EditorContainer } from './styles'
import SaveAndSubmitButtonGroup from 'components/Campaign/Editor/SaveAndSubmitButtonGroup'
import { RecordChangesKey } from 'components/Shared/CompareChangesPopup'
import EditCampaignRestricted from 'components/Shared/Permission/EditCampaignRestricted'
import { usePermission } from 'hooks/permissions'
import { CampaignStatusControl } from 'components/Shared/Permission/enums'
import PaymentConfirmation from './PaymentConfirmation'
import Text from 'particles/Text'
import Divider from 'components/Shared/Divider'

interface SaveFormProps {
    campaign: CampaignState
    isSaving: boolean
    handleSubmit: (campaignData: CampaignState, isPublish: boolean) => void
}

const SaveForm: React.FC<SaveFormProps> = ({ campaign, isSaving, handleSubmit }) => {
    const [t] = useTranslation()
    const isPublish = useRef(true)
    const isAbleToReview =
        usePermission(CampaignStatusControl.ReviewCampaign) && campaign.status === CAMPAIGN_STATUS_ENUM.FOR_REVIEW
    const isAbleToLaunch =
        (campaign.status === CAMPAIGN_STATUS_ENUM.FOR_REVIEW ||
            campaign.status === CAMPAIGN_STATUS_ENUM.WAIT_FOR_PAYMENT ||
            campaign.status === CAMPAIGN_STATUS_ENUM.READY_FOR_LAUNCH) &&
        usePermission(CampaignStatusControl.LaunchCampaign)
    const handleSubmitForm = (data: any) => {
        localStorage.removeItem(RecordChangesKey.IS_CAMPAIGN_VALUE_CHANGE)
        handleSubmit(data, isPublish.current)
    }

    return (
        <SaveContainer>
            <div>
                <div className="form-field">
                    <EditorContainer>
                        <Text scale="H4">{t('campaignEditor.campaignPaymentTitle')}</Text>
                        <Divider className="first-divider" />
                        <PaymentConfirmation />
                    </EditorContainer>
                </div>
                <EditCampaignRestricted
                    campaignStatus={campaign && campaign.status}
                    isEditBrief
                    isEditDeadline
                    isAbleToReview={isAbleToReview}
                    isAbleToLaunch={isAbleToLaunch}
                >
                    <SaveAndSubmitButtonGroup
                        disableSave={isSaving}
                        disableSubmit={isSaving}
                        campaign={campaign}
                        onSubmit={(e: React.MouseEvent<HTMLButtonElement>): void => {
                            e.preventDefault()
                            isPublish.current = true
                            handleSubmitForm(campaign)
                        }}
                        onSave={(e: React.MouseEvent<HTMLButtonElement>): void => {
                            e.preventDefault()
                            isPublish.current = false
                            handleSubmitForm(campaign)
                        }}
                    />
                </EditCampaignRestricted>
            </div>
        </SaveContainer>
    )
}
export default SaveForm
